import { useState, useEffect } from "react";
import "../../../assets/css/staff.css";
import TableControls from "../../../components/TableControls";
import BaseModal from "../../../components/BaseModal";
import { useToast } from "../../../context/ToastContext";
import { NIGERIA_STATES_LGAS } from "../../../data/nigeriaStatesLgas";

import GlobalLoader from "../../../components/GlobalLoader";



/* ================= API ================= */
const BASE_URL = process.env.REACT_APP_API_BASE;



if (!BASE_URL) {
  console.warn("REACT_APP_API_BASE is not defined");
}

const API_BASE = `${BASE_URL}/users/user.php`;

const HRM_API = `${BASE_URL}/hrm/hrm_settings.php`;


export default function StaffManagement() {

  const [editingUser, setEditingUser] = useState(null);

  const [globalLoading, setGlobalLoading] = useState(false);

  const { showToast } = useToast();
  const [staffList, setStaffList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAdd, setShowAdd] = useState(false);
  

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const startIndex = (currentPage - 1) * rowsPerPage;

  const paginatedStaff = staffList.slice(
    startIndex,
    startIndex + rowsPerPage
  );

const handleUpdateStaff = async (form) => {
  try {
    setGlobalLoading(true);

    const res = await fetch(API_BASE, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ...form,
        id: editingUser.id,
      }),
    });

    const result = await res.json().catch(() => ({}));

    if (!res.ok) {
      throw new Error(result?.message || "Failed to update user");
    }

    showToast("success", "User Updated", "Staff updated successfully");

    setShowAdd(false);
    setEditingUser(null);
    fetchStaff();

    return true;

  } catch (error) {
    showToast("error", "Update Failed", error.message);
    return false;
  } finally {
    setGlobalLoading(false);
  }
};


  const totalPages = Math.ceil(staffList.length / rowsPerPage);

  /* ================= FETCH STAFF ================= */
  const fetchStaff = async () => {
  try {
    setLoading(true);

    const res = await fetch(API_BASE);

    // 🔥 Check HTTP status first
    if (!res.ok) {
      throw new Error(`Server error: ${res.status}`);
    }

    const result = await res.json();

    // 🔥 Handle different API response formats safely
    const staffData = Array.isArray(result?.data)
      ? result.data
      : Array.isArray(result)
      ? result
      : [];

    setStaffList(staffData);
    setCurrentPage(1);

  } catch (error) {
    console.error("Fetch staff error:", error);

    showToast(
      "error",
      "Load Failed",
      "Unable to fetch staff records. Please try again."
    );
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    fetchStaff();
  }, []);

  /* ================= ADD STAFF ================= */
  const handleAddStaff = async (form) => {
  try {
    setGlobalLoading(true); // 🔥 START GLOBAL LOADER

    const res = await fetch(API_BASE, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form),
    });

    const result = await res.json().catch(() => ({}));

    if (!res.ok) {
      throw new Error(result?.message || "Failed to create user");
    }

    showToast(
      "success",
      "User Added Successfully",
      `Temporary Password: ${result?.data?.temp_password || "Generated"}`
    );

    setShowAdd(false);
    fetchStaff();

    return true; // ✅ success

  } catch (error) {
    console.error("Add staff error:", error);

    showToast(
      "error",
      "Creation Failed",
      error.message || "Something went wrong"
    );

    return false; // ❌ failed

  } finally {
    setGlobalLoading(false); // 🔥 STOP GLOBAL LOADER
  }
};


  return (
    <div className="staff-page">

      <GlobalLoader isOpen={globalLoading} />
      

      {/* ================= HEADER ================= */}
      <div className="page-header">
        <div className="page-header-left">
          <h2 className="page-title">Staff Management</h2>
          <p className="page-subtitle">
            Manage staff accounts and access
          </p>
        </div>

        <button
          className="btn btn-primary add-staff-btn"
          onClick={() => setShowAdd(true)}
        >
          + Add Staff
        </button>
      </div>

      {/* ================= TABLE ================= */}
   <div className="card">
  <TableControls
    totalItems={staffList.length}
    currentPage={currentPage}
    rowsPerPage={rowsPerPage}
    onPageChange={setCurrentPage}
    onRowsPerPageChange={setRowsPerPage}
  />

  <div className="table-wrapper">
    <table>
      <thead>
        <tr>
          <th>No.</th>
          <th>Name</th>
          <th>Email</th>
         <th>Phone</th>
<th>State</th>
<th>LGA</th>
<th>System Role</th>
<th>Designation</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>

      <tbody>
        {loading ? (
          <tr>
           <td colSpan="10" className="table-loader-cell">
              <div className="staff-table-loader"></div>
            </td>
          </tr>
        ) : paginatedStaff.length === 0 ? (
          <tr>
           <td colSpan="10" className="no-data">
              No staff found
            </td>
          </tr>
        ) : (
          paginatedStaff.map((user, index) => {
            const rowNumber = startIndex + index + 1;

            return (
              <tr key={user.id}>
                <td>{rowNumber}</td>
                <td>
                  {user.first_name} {user.last_name}
                </td>
                <td>{user.email}</td>
              <td>{user.phone || "-"}</td>
<td>{user.state || "-"}</td>
<td>{user.local_government || "-"}</td>
<td>{user.role}</td>
<td>{user.designation || "-"}</td>
                <td>
              <span className={`badge ${user.status === "active" ? "badge-success" : "badge-muted"}`}>
  {user.status}
</span>
                </td>
                <td>
                  <button
                    className="action-btn"
                  onClick={() => {
  setEditingUser(user);
  setShowAdd(true);
}}
                  >
                    Edit
                  </button>
                </td>
              </tr>
            );
          })
        )}
      </tbody>
    </table>
  </div>
</div>
      {/* ================= ADD STAFF MODAL ================= */}
    <BaseModal
  isOpen={showAdd}
  title={editingUser ? "Edit Staff" : "Add Staff"}
  onClose={() => {
    setShowAdd(false);
    setEditingUser(null);
  }}
  size="lg"
  closeOnOverlay={false}
>
       <StaffForm
  user={editingUser}
  onSubmit={editingUser ? handleUpdateStaff : handleAddStaff}
  onClose={() => {
    setShowAdd(false);
    setEditingUser(null);
  }}
/>
      </BaseModal>
    </div>
  );
}

/* ================= STAFF FORM ================= */
function StaffForm({ user, onSubmit, onClose }) {
  const [showConfirm, setShowConfirm] = useState(false);
  
  const [designations, setDesignations] = useState([]);

  const [roles, setRoles] = useState([]);

  useEffect(() => {
const loadHRMSettings = async () => {
    try {
      const res = await fetch(HRM_API, {
        credentials: "include",
      });

      const result = await res.json();

     if (res.ok && result.success) {
  setDesignations(result.data?.designations || []);
  setRoles(result.data?.roles || []);
}
    } catch (err) {
   console.error("Failed to load HRM settings:", err);
    }
  };

 loadHRMSettings();
}, []);

const [form, setForm] = useState({
  first_name: "",
  last_name: "",
  email: "",
  role: "",
 state: "",
local_government: "",
phone: "",
  gender: "",
designation: "",
});

useEffect(() => {
  if (user) {
    setForm({
      first_name: user.first_name || "",
      last_name: user.last_name || "",
      email: user.email || "",
    role: user.role || "",
designation: user.designation || "",
state: user.state || "",
local_government: user.local_government || "",
phone: user.phone || "",
gender: user.gender || "",
    });
  } else {
    // Reset form when adding new
    setForm({
      first_name: "",
      last_name: "",
      email: "",
    role: "",
designation: "",
state: "",
local_government: "",
phone: "",
gender: "",
    });
  }
}, [user]);
const handleChange = (e) => {
  const { name, value } = e.target;

  if (name === "state") {
    setForm({
      ...form,
      state: value,
      local_government: "",
    });
    return;
  }

  setForm({ ...form, [name]: value });
};

  const confirmSubmit = async () => {
  const success = await onSubmit(form);

if (success) {
  setForm({
    first_name: "",
    last_name: "",
    email: "",
  role: "",
designation: "",
state: "",
local_government: "",
phone: "",
gender: "",
    });
  }

  setShowConfirm(false);
};

  return (
    <>
      <form
        onSubmit={(e) => {
          e.preventDefault();

        setShowConfirm(true);
        }}
      >
        <div className="form-grid">
          <div className="form-group">
            <label>First Name</label>
            <input
              name="first_name"
              value={form.first_name}
              onChange={handleChange}
              className="form-control"
              required
            />
          </div>

          <div className="form-group">
            <label>Last Name</label>
            <input
              name="last_name"
              value={form.last_name}
              onChange={handleChange}
              className="form-control"
              required
            />
          </div>

          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              className="form-control"
              required
            />
          </div>

       <div className="form-group">
  <label>System Role</label>
  <select
    name="role"
    value={form.role}
    onChange={handleChange}
    className="form-select"
    required
  >
   <option value="">Select system role</option>

{roles.length === 0 ? (
  <option value="" disabled>No roles available</option>
) : (
  roles.map((role) => (
    <option key={role} value={role}>
      {role}
    </option>
  ))
)}
  </select>
</div>

<div className="form-group">
  <label>Designation</label>
  <select
    name="designation"
    value={form.designation}
    onChange={handleChange}
    className="form-select"
    required
  >
    <option value="">Select designation</option>

    {designations.length === 0 ? (
     <option value="" disabled>
  {designations.length === 0 ? "No designations available" : "Select designation"}
</option>
    ) : (
     designations.map((item) => (
      <option key={item} value={item}>
  {item}
</option>
      ))
    )}
  </select>
</div>

          <div className="form-group">
            <label>State</label>
            <select
              name="state"
              value={form.state}
              onChange={handleChange}
              className="form-select"
              required
            >
              <option value="">Select State</option>
             {Object.keys(NIGERIA_STATES_LGAS).map((state) => (
                <option key={state} value={state}>
                  {state}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
  <label>Local Government</label>
  <select
    name="local_government"
    value={form.local_government}
    onChange={handleChange}
    className="form-select"
    required
    disabled={!form.state}
  >
    <option value="">
      {form.state ? "Select Local Government" : "Select state first"}
    </option>

    {(NIGERIA_STATES_LGAS[form.state] || []).map((lga) => (
      <option key={lga} value={lga}>
        {lga}
      </option>
    ))}
  </select>
</div>

          <div className="form-group">
            <label>Phone Number</label>
            <input
              type="tel"
              name="phone"
              value={form.phone}
              onChange={handleChange}
              className="form-control"
              required
            />
          </div>

          <div className="form-group">
            <label>Gender</label>
            <select
              name="gender"
              value={form.gender}
              onChange={handleChange}
              className="form-select"
              required
            >
              <option value="">Select gender</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
            </select>
          </div>

       

        </div>

        <div className="modal-actions">
      <button
  type="button"
  className="btn btn-outline"
  onClick={() => setShowConfirm(false)}
>
  Cancel
</button>

        <button
  type="submit"
  className="btn btn-primary"
>
  Save
</button>
        </div>
      </form>

      {/* CONFIRMATION MODAL */}
    <BaseModal
  isOpen={showConfirm}
  title={user ? "Confirm Staff Update" : "Confirm Staff Creation"}
  onClose={() => setShowConfirm(false)}
  size="sm"
  closeOnOverlay={false}
  showClose={false}   // 🔥 REMOVE THE X BUTTON
>
        <div style={{ padding: "10px 0" }}>
        <p>
  {user
    ? "Are you sure you want to update this staff account?"
    : "Are you sure you want to create this staff account?"}
</p>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              marginTop: "20px",
            }}
          >
            <button
              type="button"
              className="btn btn-outline"
              onClick={() => setShowConfirm(false)}
             
            >
              Cancel
            </button>

     <button
  type="button"
  className="btn btn-primary"
  onClick={confirmSubmit}
>
  Confirm
</button>
          </div>
        </div>
      </BaseModal>
    </>
  );
}